import { render, staticRenderFns } from "./BuyChannelDropdownField.vue?vue&type=template&id=b0e690b4"
import script from "./BuyChannelDropdownField.vue?vue&type=script&lang=ts"
export * from "./BuyChannelDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0e690b4')) {
      api.createRecord('b0e690b4', component.options)
    } else {
      api.reload('b0e690b4', component.options)
    }
    module.hot.accept("./BuyChannelDropdownField.vue?vue&type=template&id=b0e690b4", function () {
      api.rerender('b0e690b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/BuyChannelDropdownField.vue"
export default component.exports